import React from "react";
import { useEffect, useState } from 'react';
import { getUsers } from '../requests/getUsers';
import { Estafados } from "./Estafados";
import { DownloadOptions } from "./DownloadOptions";
import { SeoSearchProfile } from "./SeoSearchProfile";
import { useParams } from "react-router-dom";
import { DetailedUserCard } from "./DetailedUserCard";
import { WalletsDetailsContent } from "./WalletsDetailsContent";
import { WalletUrlToken } from "./WalletUrlToken";


export const UserInformation = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (id) {
      getUsers(id).then((response) => {
        setUser(response);
      });
    }
  }, [id]);

  return (
    user ? (
      <>
        <SeoSearchProfile user={user} />
        <DetailedUserCard user={user} />
        <Estafados scammedUsers={user.children.filter(child => child.id !== user.parent_id)} />
        <DownloadOptions user={user} />
        <WalletUrlToken />
        {user.is_xlsx_available === 1 && <WalletsDetailsContent />}
      </>
    ) : (
      id && <p className="text-center text-gray-500">Loading user...</p>
    )
  );
};
